export const translateBeneficiaryStatus = status => {
  const dictionary = {
    active: 'Ativo',
    inactive: 'Inativo',
    waiting: 'A Ativar',
  }

  return dictionary[status]
}

export const translatePackageOrderStatus = packageOrder => {
  if (!packageOrder) {
    throw new Error('The packageOrder parametter is required')
  }

  const { payment_type, is_payment_confirmed } = packageOrder

  if (payment_type === 'no-payment') {
    return 'Crédito'
  }

  return is_payment_confirmed ? 'Confirmado' : 'Pendente'
}

export const translateCommissionedCommissionType = commissionType => {
  const dictionary = {
    standard: 'Padrão',
    special: 'Personalizado',
  }

  return dictionary[commissionType] || dictionary['standard']
}

export const translateCommissionedCreditType = creditType => {
  const dictionary = {
    standard: 'Padrão',
    special: 'Personalizado',
  }

  return dictionary[creditType] || dictionary['standard']
}

export const translatePlanStatus = status => {
  const dictionary = {
    SPE: 'Especial',
    PAD: 'Padrão',
    CAN: 'Cancelado',
  }

  return dictionary[status] || dictionary['CAN']
}

export const translateClientFreeTrialSatus = client => {
  if (!client.tested_free_trial_plan) {
    return 'Não utilizado'
  }

  const freeTrialEndDate = new Date(client.free_trial_end_date)
  const today = Date.now()

  if (freeTrialEndDate > today) {
    const parts = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).formatToParts(
      freeTrialEndDate,
    )

    const day = parts.find(({ type }) => type === 'day').value
    const month = parts.find(({ type }) => type === 'month').value

    return `Em utilização - até ${day}/${month}`
  }

  return 'Utilizado'
}

export const translateCommissionedTransactionType = (type, isStaff = false) => {
  const dictionary = {
    in: isStaff ? 'Comissão' : 'Entrada',
    out: isStaff ? 'Saque' : 'Saída',
    admin_payment: 'Pagamento',
  }

  return dictionary[type] || dictionary['out']
}

export const translateCommissionedRegistrationStatus = registrarionStatus => {
  const dictionary = {
    rejected: 'Recusado',
    awaiting_adjusts: 'Requer Ajustes',
    approved: 'Aprovado',
    awaiting_approval: 'Aguardando Aprovação',
  }

  return dictionary[registrarionStatus] || dictionary['awaiting_adjusts']
}

export const translatePagbankTransactionStatus = transactionStatus => {
  const dictionary = {
    pending: 'A liberar',
    complete: 'Liberado',
    failed: 'Reprovado',
  }

  return dictionary[transactionStatus] || dictionary['pending']
}

export const translateGiftCardPaymentStatus = status => {
  const dictionary = {
    INITIATED: 'Processando pedido',
    PENDING: 'Aguardando Pagamento',
    COMPLETE: 'Pagamento aprovado',
    CANCELLED: 'Pagamento cancelado',
    ERROR: 'Erro no pagamento',
  }

  return dictionary[status]
}

export const translateGiftCardType = card_type => {
  const dictionary = {
    GIFT_CARD: 'Valor',
    PLANS: 'Pacotes',
  }

  return dictionary[card_type] || '-'
}
